// Human labels for every booking / payment / room / record status enum. The colour for each
// status lives in one place too: the `.status--<value>` rules in styles/index.css.
const LABELS: Record<string, string> = {
  PENDING: "Pending",
  CONFIRMED: "Confirmed",
  CHECKED_IN: "Checked in",
  CHECKED_OUT: "Checked out",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  REJECTED: "Rejected",
  EXPIRED: "Expired",
  AUTO_CANCELLED: "Auto-cancelled",
  NO_SHOW: "No-show",
  UNPAID: "Unpaid",
  PARTIAL: "Partially paid",
  PAID: "Paid",
  REFUNDED: "Refunded",
  REFUND_DUE: "Refund due",
  AVAILABLE: "Available",
  OCCUPIED: "Occupied",
  RESERVED: "Reserved",
  MAINTENANCE: "Maintenance",
  BLOCKED: "Blocked",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export function statusLabel(status: string | null | undefined): string {
  if (!status) return "";
  const key = status.toUpperCase();
  return LABELS[key] ?? key.charAt(0) + key.slice(1).toLowerCase().replace(/_/g, " ");
}

export function statusClass(status: string | null | undefined): string {
  return `status status--${(status ?? "").toLowerCase()}`;
}
